import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/domestic-shipping-services.jpg'),
    alt: 'domestic shipping services page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'domestic shipping services page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Domestic Shipping <span>Services</span> <span>For Your Needs</span>',
  description:
    'Ready to send a special gift or important business package across the country? Ensure it arrives safely, quickly, and affordably with ShipAndStorage, your reliable shipping partner.',
  points: [
    '6 Months Free Storage',
    'Convenient Drop-Off & Pickup Options',
    'Global Shipping Network',
    'Student-Friendly Solutions'
  ],
  image: {
    url: '/images/v2/pages/main-pages/domestic-shipping-services/hero-image.jpg',
    alt: 'college storage services page'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Start Domestic Shipment' }
}

export const whyChooseUsSectionContent = {
  title: 'How Our Domestic Shipping Services Work',
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Start Shipping With Us' },

  cards: [
    {
      id: 1,
      title: 'Book Online with Ease',
      description: 'Use our intuitive platform to choose shipping options, input details, and pay securely.',
      image: {
        src: '/images/v2/pages/main-pages/domestic-shipping-services/book-online-with-ease.svg',
        alt: 'Book Online with Ease service'
      }
    },
    {
      id: 2,
      title: 'Prepare Your Shipment',
      description: 'Pack items using sturdy materials and affix provided shipping labels securely.',
      image: {
        src: '/images/v2/pages/main-pages/domestic-shipping-services/prepare-your-shipment.svg',
        alt: 'Prepare Your Shipment service'
      }
    },
    {
      id: 3,
      title: 'Arrange Pickup or Drop-off',
      description: 'Schedule a convenient pickup or drop your items off at a nearby partner location.',
      image: {
        src: '/images/v2/pages/main-pages/domestic-shipping-services/arrange-pickup-or-drop-off.svg',
        alt: 'Arrange Pickup or Drop-off service'
      }
    },
    {
      id: 4,
      title: 'Track Your Shipment',
      description: 'Monitor your shipment in real-time until it’s safely delivered to its destination.',
      image: {
        src: '/images/v2/pages/main-pages/domestic-shipping-services/track-your-shipment.svg',
        alt: 'Track Your Shipment service'
      }
    }
  ]
}

export const serviceTipsSectionSectionContent = {
  title: 'Key Benefits of Domestic Shipping',
  description:
    'Domestic shipping with ShipAndStorage comes packed with advantages that cater to personal and business needs alike:',

  cards: [
    {
      id: 1,
      title: 'Nationwide Reach',
      description:
        'Our services cover every corner of the country, ensuring your package gets where it needs to be, no matter the destination.',
      image: {
        src: '/images/v2/pages/main-pages/domestic-shipping-services/nationwide-reach.svg',
        alt: 'Nationwide Reach service'
      }
    },
    {
      id: 2,
      title: 'Real-Time Tracking',
      description:
        "Stay informed at every stage with precise, real-time updates on your shipment's location and estimated arrival time.",
      image: {
        src: '/images/v2/pages/main-pages/domestic-shipping-services/real-rime-tracking.svg',
        alt: 'Real-Time Tracking service'
      }
    },
    {
      id: 3,
      title: 'Custom Solutions',
      description:
        'We tailor our services to meet your specific needs, whether you’re shipping small parcels or managing bulk shipments.',
      image: {
        src: '/images/v2/pages/main-pages/domestic-shipping-services/custom-solutions.svg',
        alt: 'Custom Solutions service'
      }
    },
    {
      id: 4,
      title: 'Eco-Friendly Options',
      description: 'Reduce your environmental impact with our sustainable packaging and green delivery methods.',
      image: {
        src: '/images/v2/pages/main-pages/domestic-shipping-services/eco-friendly-options.svg',
        alt: 'Eco-Friendly Options service'
      }
    },
    {
      id: 5,
      title: 'Secure Handling',
      description:
        'Your shipments are treated with the utmost care, ensuring they arrive in perfect condition every time.',
      image: {
        src: '/images/v2/pages/main-pages/domestic-shipping-services/secure-handling.svg',
        alt: 'Secure Handling service'
      }
    },
    {
      id: 6,
      title: 'Flexible Timelines',
      description: 'Choose from same-day, expedited, or standard delivery options to match your schedule and budget.',
      image: {
        src: '/images/v2/pages/main-pages/domestic-shipping-services/flexible-timelines.svg',
        alt: 'Flexible Timelines service'
      }
    }
  ]
}

export const benefitsSectionSectionContent = {
  title: 'How We Ensure Safe and Secure Domestic Shipping',

  cards: [
    {
      id: 1,
      title: 'Premium Packaging Standards',
      description:
        'We use high-quality packaging materials designed to minimize risks during transit, ensuring your items are safe from potential damage.',
      image: {
        src: '/images/v2/pages/main-pages/domestic-shipping-services/premium-packaging-standards.svg',
        alt: 'Premium Packaging Standards service'
      }
    },
    {
      id: 2,
      title: 'Insurance Coverage',
      description:
        'Optional insurance is available for valuable items, giving you peace of mind that your shipment is protected in case of loss or damage.',
      image: {
        src: '/images/v2/pages/main-pages/domestic-shipping-services/insurance-coverage.svg',
        alt: 'Insurance Coverage service'
      }
    },
    {
      id: 3,
      title: 'Partnered with Industry Leaders',
      description:
        'We’ve teamed up with trusted carriers like FedEx, UPS, and DHL, leveraging their expertise for secure handling and reliable delivery.',
      image: {
        src: '/images/v2/pages/main-pages/domestic-shipping-services/partnered-with-industry-leaders.svg',
        alt: 'Partnered with Industry Leaders service'
      }
    },
    {
      id: 4,
      title: 'Climate-Controlled Warehouses',
      description:
        'For sensitive shipments, we provide climate-controlled storage to protect your items from extreme weather conditions while awaiting delivery.',
      image: {
        src: '/images/v2/pages/main-pages/domestic-shipping-services/climate-controlled-warehouses.svg',
        alt: 'Climate-Controlled Warehouses service'
      }
    }
  ]
}

export const partnersSectionContent = {
  title: 'Domestic Shipping Carriers & Rates Explained',
  description: 'Domestic luggage shipping prices vary based on weight, dimensions, delivery speed, and destination.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description:
        'FedEx offers specialized services for luggage shipping with comprehensive tracking features and secure handling options to ensure safe delivery every time.',
      image: {
        src: '/images/v2/pages/main-pages/common/fedEx.svg',
        alt: 'FedEx'
      }
    },
    {
      id: 2,
      title: 'UPS',
      description:
        'UPS is widely known for its reliable, efficient, and secure shipping services, particularly when it comes to oversized items like heavy luggage and large packages.',
      image: {
        src: '/images/v2/pages/main-pages/common/ups.svg',
        alt: 'UPS service'
      }
    }
  ]
}

export const keyFactorsSectionContent = {
  title: 'Key Factors Affecting Luggage Shipping Rates',

  cards: [
    {
      id: 1,
      title: 'Weight',
      description:
        'Heavier luggage incurs higher shipping costs, with carriers dividing fees into weight brackets like 50 lbs, 70 lbs, or 100 lbs. The more your luggage weighs, the more you’ll pay, so understanding weight limits can help plan your budget effectively.',
      image: {
        src: '/images/v2/pages/main-pages/domestic-shipping-services/weight.svg',
        alt: 'Weight'
      }
    },
    {
      id: 2,
      title: 'Dimensions',
      description:
        'Oversized luggage often comes with additional fees due to handling and space requirements. Items exceeding standard size limits may require special processing, increasing costs. It’s crucial to measure your luggage and compare carrier guidelines to avoid unexpected surcharges.',
      image: {
        src: '/images/v2/pages/main-pages/domestic-shipping-services/dimensions.svg',
        alt: 'Dimensions'
      }
    },
    {
      id: 3,
      title: 'Delivery Speed',
      description:
        'Expedited shipping services, such as overnight or 1–2 day options, significantly increase costs compared to standard delivery. While faster delivery ensures prompt arrival, budget-conscious shippers can save by opting for slower methods like 3–7 day ground services.',
      image: {
        src: '/images/v2/pages/main-pages/domestic-shipping-services/delivery-speed.svg',
        alt: 'Delivery Speed'
      }
    },
    {
      id: 4,
      title: 'Destination Zone',
      description:
        'Shipping costs vary based on the distance between the origin and destination. Carriers divide locations into zones, and longer distances result in higher rates. For cost savings, compare options and choose carriers specializing in your destination region.',
      image: {
        src: '/images/v2/pages/main-pages/domestic-shipping-services/destination-zone.svg',
        alt: 'Destination Zone'
      }
    }
  ]
}

export const forWhoSectionContent = {
  title: 'What Can You Ship Domestically with ShipAndStorage?',

  cards: [
    {
      id: 1,
      title: 'Luggage and Bags',
      description:
        'Avoid airport baggage fees by shipping your suitcases and travel essentials directly to your destination.',
      image: {
        src: '/images/v2/pages/main-pages/domestic-shipping-services/luggage-and-bags.svg',
        alt: 'Luggage and Bags service'
      }
    },
    {
      id: 2,
      title: 'Sports and Outdoor Gear',
      description: 'Ship items like skis, snowboards, golf clubs, or camping equipment for your next adventure.',
      image: {
        src: '/images/v2/pages/main-pages/domestic-shipping-services/sports-and-outdoor-gear.svg',
        alt: 'Sports and Outdoor Gear service'
      }
    },
    {
      id: 3,
      title: 'Household Goods',
      description: 'You can easily and affordably ship small furniture, electronics, or kitchen appliances.',
      image: {
        src: '/images/v2/pages/main-pages/domestic-shipping-services/household-goods.svg',
        alt: 'Household Goods service'
      }
    },
    {
      id: 4,
      title: 'Business Essentials',
      description: 'Transport promotional materials, e-commerce parcels, or trade show supplies with confidence.',
      image: {
        src: '/images/v2/pages/main-pages/domestic-shipping-services/business-essentials.svg',
        alt: 'Business Essentials service'
      }
    },
    {
      id: 5,
      title: 'Documents and Files',
      description: 'Safely deliver important paperwork, blueprints, or legal documents anywhere in the country.',
      image: {
        src: '/images/v2/pages/main-pages/domestic-shipping-services/documents-and-files.svg',
        alt: 'Documents and Files service'
      }
    },
    {
      id: 6,
      title: 'Gifts and Personal Items',
      description: 'Send birthday gifts, care packages, or personal belongings conveniently to your loved ones.',
      image: {
        src: '/images/v2/pages/main-pages/domestic-shipping-services/gifts-and-personal-items.svg',
        alt: 'Gifts and Personal Items service'
      }
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Ship Smarter with ShipAndStorage',
  description:
    'At ShipAndStorage, we make domestic shipping straightforward, efficient, and affordable. Whether it’s a personal package or business order, our tailored services ensure a hassle-free experience. Start shipping confidently with us today!',
  image: {
    src: '/images/v2/pages/main-pages/domestic-shipping-services/promotional-banner-image.svg',
    alt: 'Ship Smarter with ShipAndStorage'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Start Here' }
}

export const faqSectionContent = {
  title: 'Frequently Asked Questions',

  questions: [
    {
      id: 1,
      question: 'How do I select the right carrier for my shipment?',
      answer:
        'Choose based on delivery speed, package size, and budget. For urgent shipments, opt for FedEx or UPS Express. For cost-saving, USPS flat-rate shipping is a great option.'
    },
    {
      id: 2,
      question: 'Can I track my shipment in real-time?',
      answer:
        'Yes! Every shipment comes with a tracking number to provide you with up-to-the-minute updates on your package’s journey.'
    },
    {
      id: 3,
      question: 'Are there any restrictions on what I can ship domestically?',
      answer:
        'Certain items like hazardous materials or prohibited goods cannot be shipped. Contact us for a complete list of restricted items.'
    },
    {
      id: 4,
      question: 'Does ShipAndStorage offer pickup services?',
      answer:
        'Absolutely. Schedule a pickup at your convenience, and we’ll handle the rest to ensure a smooth shipping process.'
    },
    {
      id: 5,
      question: 'How do I calculate shipping costs?',
      answer:
        'Use our online calculator to get accurate shipping quotes based on package size, weight, and destination.'
    },
    {
      id: 6,
      question: 'Do you provide options for eco-friendly shipping?',
      answer:
        'Yes, we offer green solutions with recyclable packaging and energy-efficient delivery options to support sustainability.'
    }
  ]
}
